import { apiPost } from "@redriver/cinnamon";

const NAMESPACE = "FORGOT_PASSWORD";
const ActionTypes = {
  SendResetLink: `${NAMESPACE}/SEND_LINK`,
};

export const sendResetLink = ({ email }) => {
  return apiPost(
    ActionTypes.SendResetLink,
    "resort-reps-auth/reset-tokens",
    {
      email: email.trim(),
    },
    {
      auth: false,
    }
  );
};
